<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
      z-index="999999"
    >
      <b-button
        :disabled="busy"
        :variant="button.variant || 'primary'"
        v-for="button in buttons"
        block
        :key="button.action"
        @click.prevent="clickHandler(button)"
        >{{ $t(button.text) }}</b-button
      >
    </b-overlay>
  </div>
</template>

<script>
// {"buttons":{"staff":[{"action":"APPOINTMENT-ACCEPT","text":"Accept","variant":"success"},{"action":"APPOINTMENT-REJECT","text":"Reject","variant":"success"}]}}
export default {
  name: "chat-message-buttons",
  data() {
    return {
      busy: false,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
    };
  },
  props: {
    messageObject: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async appointmentHandler({ action, extra }) {
      console.log("appointmentHandler", { action, extra });
      if (action != "APPOINTMENT-VIEW") {
        this.busy = true;
        this.show = true;
        await this.$store.dispatch("BookingConfirmation", extra);
        this.busy = false;
        this.show = false;
      } else this.$router.push(extra);
    },
    clickHandler(button) {
      const isAppointmentActions =
        ["APPOINTMENT-ACCEPT", "APPOINTMENT-REJECT", "APPOINTMENT-VIEW"].indexOf(
          button.action
        ) > -1;
      if (isAppointmentActions) this.appointmentHandler(button);
    },
  },
  computed: {
    userRole() {
      const me = this.$store.state.auth.currentUser;
      return me.user_role == "user" ? "user" : "staff";
    },
    buttons() {
      let buttons = [];
      if (
        this.messageObject &&
        this.messageObject.meta &&
        this.messageObject.meta.buttons
      ) {
        const buttonObj = this.messageObject.meta.buttons;
        if (buttonObj.all) {
          buttons = [...buttonObj.all];
        }
        if (buttonObj[this.userRole]) {
          buttons = [...buttonObj[this.userRole]];
        }
      }
      return buttons;
    },
  },
};
</script>

<style></style>
